import { Controller, useFormContext } from 'react-hook-form';

import { RadioComponent } from 'components/common/RadioComponent/radioComponent';

import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/LinkedActivities/LinkedActivities.module.scss';
import { ActivityCodesSelect } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/LinkedActivities/components/ActivityCodesSelect/ActivityCodesSelect';
import { ClusterSelect } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/LinkedActivities/components/ClusterSelect/ClusterSelect';
import { SegmentSelect } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/LinkedActivities/components/SegmentSelect/SegmentSelect';
import { SpecificActivitiesSelect } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/LinkedActivities/components/SpecificActivitiesSelect/SpecificActivitiesSelect';
import { WbsSelect } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/LinkedActivities/components/WbsSelect/WbsSelect';
import { FormProps } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/UpdateRiskRegisterModal/components/UpdateRiskRegisterForm/UpdateRiskRegisterForm';

export const LinkedActivities = () => {
    const methods = useFormContext<FormProps>();

    const linkOption = methods.getValues('linkOption');

    const { control } = methods;

    const setLinkOption = (value: FormProps['linkOption']) => {
        methods.setValue('linkOption', value, { shouldDirty: true });
    };

    return (
        <div className={classes.formSection}>
            <div className={classes.formRow}>
                <label className={classes.label}>
                    <RadioComponent
                        name="linkOption"
                        value={'specific'}
                        checked={methods.watch('linkOption') === 'specific'}
                        onChange={() => setLinkOption('specific')}
                    />
                    Link specific tasks
                </label>
                <div
                    className={`${classes.inputWrapper} ${classes.linkedActivities} ${linkOption === 'specific' ? classes.collapsed : ''}`}
                >
                    <Controller
                        render={() => <SpecificActivitiesSelect name={'activitiesByKey.specific'} methods={methods} />}
                        name="activitiesByKey.specific"
                        control={control}
                    />
                </div>
            </div>

            <div className={classes.formRow}>
                <label className={classes.label}>
                    <RadioComponent
                        name="linkOption"
                        value={'wbs'}
                        checked={methods.watch('linkOption') === 'wbs'}
                        onChange={() => setLinkOption('wbs')}
                    />
                    Link all activities under a specific WBS
                </label>
                <div
                    className={`${classes.inputWrapper} ${classes.linkedActivities} ${linkOption === 'wbs' ? classes.collapsed : ''}`}
                >
                    <Controller
                        render={() => <WbsSelect name={'activitiesByKey.wbs'} methods={methods} />}
                        name="activitiesByKey.wbs"
                        control={control}
                    />
                </div>
            </div>

            <div className={classes.formRow}>
                <label className={classes.label}>
                    <RadioComponent
                        name="linkOption"
                        value={'activityCodes'}
                        checked={methods.watch('linkOption') === 'activityCodes'}
                        onChange={() => setLinkOption('activityCodes')}
                    />
                    Link all activities with a given Activity Code
                </label>
                <div
                    className={`${classes.inputWrapper} ${classes.linkedActivities} ${linkOption === 'activityCodes' ? classes.collapsed : ''}`}
                >
                    <Controller
                        render={() => <ActivityCodesSelect name={'activitiesByKey.activityCodes'} methods={methods} />}
                        name="activitiesByKey.activityCodes"
                        control={control}
                    />
                </div>
            </div>

            <div className={classes.formRow}>
                <label className={classes.label}>
                    <RadioComponent
                        name="linkOption"
                        value={'cluster'}
                        checked={methods.watch('linkOption') === 'cluster'}
                        onChange={() => setLinkOption('cluster')}
                    />
                    Link all activities within a reference class cluster
                </label>
                <div
                    className={`${classes.inputWrapper} ${classes.linkedActivities} ${linkOption === 'cluster' ? classes.collapsed : ''}`}
                >
                    <Controller
                        render={() => <ClusterSelect name={'activitiesByKey.cluster'} methods={methods} />}
                        name="activitiesByKey.cluster"
                        control={control}
                    />
                </div>
            </div>
            <div className={classes.formRow}>
                <label className={classes.label}>
                    <RadioComponent
                        name="linkOption"
                        value={'segment'}
                        checked={methods.watch('linkOption') === 'segment'}
                        onChange={() => setLinkOption('segment')}
                    />
                    Link all activities within a segment
                </label>
                <div
                    className={`${classes.inputWrapper} ${classes.linkedActivities} ${linkOption === 'segment' ? classes.collapsed : ''}`}
                >
                    <Controller
                        render={() => <SegmentSelect name={'activitiesByKey.segment'} methods={methods} />}
                        name="activitiesByKey.segment"
                        control={control}
                    />
                </div>
            </div>
            <div className={classes.formRow}>
                <label className={classes.label}>
                    <RadioComponent
                        name="linkOption"
                        value={'all'}
                        checked={methods.watch('linkOption') === 'all'}
                        onChange={() => setLinkOption('all')}
                    />
                    Link all project activities
                </label>
            </div>
        </div>
    );
};
